<div class="pt-3" *ngIf="privateEventNotFound">
  <h2>Event not found</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="mt-3 alert alert-danger" *ngIf="missingPermission">
  You need the "Can manage events" permission in order to
  <span *ngIf="isNewPrivateEvent">create a private event.</span>
  <span *ngIf="!isNewPrivateEvent">modify this private event.</span>
</div>

<div class="pt-3 pl-md-4 mb-6" *ngIf="!privateEventNotFound && (serverError === null) && !missingPermission">
  <div class="row">
    <div class="col">
      <p class="mt-2" style="width:100%;text-align:center">
        <span *ngIf="isNewPrivateEvent">NEW PRIVATE EVENT</span>
        <span *ngIf="!isNewPrivateEvent && (privateEvent.id === null)">LOADING PRIVATE EVENT...</span>
        <span *ngIf="!isNewPrivateEvent && (privateEvent.id !== null)">EDIT PRIVATE EVENT: {{ privateEvent.event_type_name }}</span>
      </p>
    </div>
  </div>

  <div class="mb-3 border-rounded-10">

    <nav class="navbar navbar-expand navbar-light bg-light event-create-edit-nav pl-2">
      <ul class="navbar-nav" *ngIf="isNewPrivateEvent">
        <li class="nav-item">
          <a routerLink="/events/scheduled/private-event/add" class="nav-link active" href="#">Event Details</a>
        </li>
        <li class="nav-item">
          <a routerLink="/nolink" class="nav-link disabled" href="#">Reservations</a>
        </li>
        <li class="nav-item">
          <a routerLink="/nolink" class="nav-link disabled" href="#">Payment</a>
        </li>
      </ul>
      <app-private-event-setup-nav *ngIf="!isNewPrivateEvent"
                                   [loadingEvent]="loadingPrivateEvent"
                                   [privateEvent]="privateEvent"></app-private-event-setup-nav>
    </nav>

    <div class="m-4"
         *ngIf="loadingPrivateEvent || loadingRequestBooking">
      <h3 class="text-muted">Loading...</h3>
    </div>

    <form (submit)="save()" class="m-4"
          *ngIf="!(loadingPrivateEvent || loadingRequestBooking)">

      <ng-container *ngIf="requestBooking">

        <button class="btn btn-sm btn-outline-primary"
                type="button" (click)="showRequestBooking = !showRequestBooking">
          {{ showRequestBooking ? 'Hide Request Booking Info' : 'Show Request Booking Info' }}
        </button>

        <div *ngIf="showRequestBooking" class="mt-2">

          <div class="mb-2">
            Booked By:
            <span *ngIf="!requestBooking.booked_by_customer_id"
                  class="text-muted">
              Non-Logged In Customer
            </span>
            <a *ngIf="requestBooking.booked_by_customer_id"
               routerLink="/customers/{{ requestBooking.booked_by_customer_id }}">
              {{ requestBooking.booked_by_customer_first_name }}
              {{ requestBooking.booked_by_customer_last_name }}
            </a>

            <br>

            Booking Completed At:
            <b>
              {{ dateStringFromISO8601(requestBooking.purchase_completed_at, requestBooking.location_time_zone) }},
              {{ timeStringFromISO8601(requestBooking.purchase_completed_at, requestBooking.location_time_zone) }}
            </b>
          </div>

          <div class="mb-2">
            Request Event Type:
            <b>{{ requestBooking.event_type_name }}</b>

            <br>

            Requested Time Slot:
            <b>
              {{ dateStringFromISO8601(requestBooking.event_parts[0].event_start_datetime, requestBooking.location_time_zone) }},
              {{ timeStringFromISO8601(requestBooking.event_parts[0].event_start_datetime, requestBooking.location_time_zone) }}
            </b>

            <br>

            Requested Location:
            <b>
              {{ requestBooking.location_name }}
            </b>
            <small class="text-muted d-block">
              This time slot and location have been prefilled below.
            </small>
          </div>

          <div class="mb-2">
            Amount Paid:
            <b>
              {{ orgConfigService.formatCurrency(requestBooking.unrefunded_currency_amount) }}
            </b>
            <small class="text-muted d-block"
                   *ngIf="requestBooking.unrefunded_currency_amount > 0">
              This payment will be applied towards the private event's fee once it is created.
            </small>
          </div>

          <div class="mb-2" *ngFor="let questionName of Object.keys(requestBooking.question_responses)">
            {{ questionName }}{{ !['.', '?'].includes(questionName.slice(-1)) ? ':' : '' }}
            <b>
              <ng-container *ngIf="propExistsAndIsNonEmpty(requestBooking.question_responses[questionName])">
                {{ requestBooking.question_responses[questionName] }}
              </ng-container>
              <span class="text-muted"
                    *ngIf="!propExistsAndIsNonEmpty(requestBooking.question_responses[questionName])">
                No response
              </span>
            </b>
          </div>

        </div>

        <div class="alert alert-danger mt-2"
             *ngIf="errors.request_booking_id">
          {{ errors.request_booking_id }}
        </div>

        <hr>

      </ng-container>

      <div class="form-group mb-4">
        <label>Event Type</label>
        <div class="row">
          <div class="col-6">
            <select class="custom-select" name="event_type_id"
                    *ngIf="!loadingEventTypes && (eventTypeList.length > 0)"
                    [(ngModel)]="privateEvent.event_type_id"
                    (ngModelChange)="loadPricingMatrices()"
                    [disabled]="!isNewPrivateEvent"
                    [class.disabled]="!isNewPrivateEvent">
              <option [ngValue]="null" class="text-muted">---</option>
              <option *ngFor="let eventType of eventTypeList"
                      [ngValue]="eventType.id">
                {{ eventType.name }}
              </option>
            </select>
            <select class="custom-select disabled" disabled
                    *ngIf="loadingEventTypes">
              <option>Loading...</option>
            </select>
            <select class="custom-select disabled" disabled
                    *ngIf="!loadingEventTypes && (eventTypeList.length === 0)">
              <option>No active multi-part/one-off event types</option>
            </select>
          </div>
        </div>
        <div class="form-text text-danger">
          {{ errors.event_type_id }}
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="form-group">
            <label for="selectLocation">Location</label>
            <select class="custom-select"
                    id="selectLocation" name="selectLocation"
                    [(ngModel)]="privateEvent.location_id"
                    [disabled]="loadingPrivateEvent || !isNewPrivateEvent"
                    [class.disabled]="loadingPrivateEvent || !isNewPrivateEvent">
              <option *ngFor="let location of locationService.getLocations()"
                      [ngValue]="location.id">
                {{ location.name }}
              </option>
            </select>
            <div class="form-text text-danger">{{ errors.location_id }}</div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <ng-container *ngIf="loadingPrivateEvent || loadingLocationAreas">
              <label>Area</label>
              <a class="float-right" routerLink="/areas-config" target="_blank">
                Configure Areas
              </a>
              <select class="custom-select" disabled>
                <option>Loading...</option>
              </select>
            </ng-container>
            <ng-container *ngIf="!(loadingPrivateEvent || loadingLocationAreas)">
              <label for="locationAreaSelect">
                Area
              </label>
              <div class="float-right">
                <a href="#"
                   (click)="$event.preventDefault();loadLocationAreas();">
                  Refresh Areas
                </a>
                |
                <a routerLink="/areas-config" target="_blank">
                  Configure Areas
                </a>
              </div>
              <select class="custom-select" id="locationAreaSelect" name="gym_area_id"
                      [(ngModel)]="privateEvent.location_area_id">
                <option [ngValue]="null">No Area</option>
                <option *ngFor="let locationArea of getLocationAreasForLocation()" [ngValue]="locationArea.id">
                  {{ locationArea.name }} (Capacity {{ locationArea.capacity }})
                </option>
              </select>
            </ng-container>
            <small class="form-text text-muted clearfix">
              Setting an area will cap capacity for the event once the area's capacity has been met. This is optional, and capacity may also be set per time slot.
            </small>
            <div class="form-text text-danger">{{ errors.location_area_id }}</div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="occurrenceNameInput">Staff Occurrence Name (optional)</label>
            <input type="text" class="form-control" name="occurrence_name" id="occurrenceNameInput"
                   [(ngModel)]="privateEvent.occurrence_name">
            <small class="form-text text-muted">
              This is displayed on the Scheduled Events page after the event type name to help staff distinguish between occurrences of the same event type. It is not displayed to customers.
            </small>
            <div class="form-text text-danger">{{ errors.occurrence_name }}</div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for="customer_facing_name">Customer Occurrence Name (optional)</label>
            <input type="text" class="form-control" name="customer_facing_name" id="customer_facing_name"
                   [(ngModel)]="privateEvent.customer_facing_name">
            <small class="form-text text-muted">
              This is displayed in the Climber App after the event type name to help customers distinguish between occurrences of the same event type.
            </small>
            <div class="form-text text-danger">{{ errors.customer_facing_name }}</div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <ng-container *ngIf="loadingPrivateEvent || loadingBenefitMemberships">
              <label>Benefit Membership (optional)</label>
              <select class="custom-select" disabled>
                <option>Loading...</option>
              </select>
            </ng-container>
            <ng-container *ngIf="!(loadingPrivateEvent || loadingBenefitMemberships)">
              <label for="benefit_membership_id">
                Benefit Membership (optional)
              </label>
              <div class="float-right">
                <a href="#"
                   (click)="$event.preventDefault();loadBenefitMemberships();">
                  Refresh Memberships
                </a>
                |
                <a routerLink="/memberships-and-passes" target="_blank">
                  Configure Memberships
                </a>
              </div>
              <select class="custom-select"
                      id="benefit_membership_id"
                      name="benefit_membership_id"
                      [(ngModel)]="privateEvent.benefit_membership_id">
                <option [ngValue]="null">No Benefit Membership</option>
                <option *ngIf="benefitMembershipRetired(privateEvent.benefit_membership_id)"
                        [ngValue]="privateEvent.benefit_membership_id">
                  {{ privateEvent.benefit_membership_name }} (Retired)
                </option>
                <option *ngFor="let membership of benefitMembershipList"
                        [ngValue]="membership.id">
                  {{ membership.name }}
                </option>
              </select>
            </ng-container>
            <small class="form-text text-muted clearfix">
              Each participant booked onto this event receives the benefit membership from the beginning of the event's first day through the end of its last day, plus the additional days. Participants already booked receive it when the event is saved.
              <br>
              Only active memberships with Purchase Type "Benefit" may be selected.
            </small>
            <div class="form-text text-danger">{{ errors.benefit_membership_id }}</div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for="benefit_membership_additional_days">
              Benefit Additional Days After Event
            </label>
            <div class="input-group">
              <input type="number" class="form-control"
                     name="benefit_membership_additional_days"
                     id="benefit_membership_additional_days"
                     min="0" max="365" step="1"
                     [disabled]="privateEvent.benefit_membership_id === null"
                     [(ngModel)]="privateEvent.benefit_membership_additional_days">
              <div class="input-group-append">
                <span class="input-group-text">days</span>
              </div>
            </div>
            <small class="form-text text-muted">
              The number of additional days after the event's last day that the benefit membership should extend. For example, with 13 additional days, an event on 5 October grants the membership through the end of 18 October.
            </small>
            <div class="form-text text-danger">{{ errors.benefit_membership_additional_days }}</div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col">
          <button class="btn btn-sm btn-primary" type="button"
                  (click)="openQuickAddOccurrencesModal()">
            Quick Add Dates
          </button>
        </div>
      </div>

      <div class="row mt-3" *ngFor="let eventPart of privateEvent.event_parts; let idx = index;">

        <div class="col-4">
          <label>Date *</label>
          <app-date-picker [id]="'date' + idx.toString()"
                           [(content)]="eventPart.start_date"></app-date-picker>
        </div>
        <div class="col-3">
          <label>Start Time *</label>
          <input type="time" step="60"
                 class="form-control"
                 [name]="'startTime' + idx.toString()"
                 [(ngModel)]="eventPart.start_time">
        </div>
        <div class="col-3">
          <label>Duration (minutes) *</label>
          <input type="number" class="form-control"
                 min="1" max="1440" step="1"
                 [name]="'duration_minutes' + idx.toString()"
                 [(ngModel)]="eventPart.duration_minutes">
        </div>
        <div class="col-2">
          <label>&nbsp;</label>
          <button class="btn btn-outline-danger d-block" type="button"
                  (click)="privateEvent.event_parts.splice(idx, 1)">
            Remove
          </button>
        </div>

        <div class="col-xl-6 col-lg-8 col-md-10 col-12 mt-2">
          <app-edit-event-instructors [instructors]="eventPart.instructors"
                                      [useIsSub]="true"
                                      [id]="'editInstructors' + idx.toString()"></app-edit-event-instructors>
        </div>

      </div>

      <div class="form-text text-danger">
        {{ errors.event_parts }}
      </div>

      <button class="btn btn-link pl-0 d-block mt-3 mb-4" type="button"
              (click)="addNewEventPart()">
        Add Date
      </button>

      <div class="form-group">
        <label for="pricing_matrix_id">Pricing Matrix</label>
        <div class="row">
          <div class="col-sm-6">
            <select class="custom-select"
                    name="pricing_matrix_id"
                    id="pricing_matrix_id"
                    *ngIf="!loadingPricingMatrices && privateEvent.event_type_id"
                    [(ngModel)]="privateEvent.pricing_matrix_id"
                    [disabled]="!isNewPrivateEvent"
                    [class.disabled]="!isNewPrivateEvent">
              <option [ngValue]="null" class="text-muted">None</option>
              <option *ngFor="let pricingMatrix of pricingMatrixList"
                      [ngValue]="pricingMatrix.id">
                {{ pricingMatrix.name }}
              </option>
            </select>
            <select class="custom-select disabled" disabled
                    *ngIf="loadingPricingMatrices">
              <option>Loading...</option>
            </select>
            <select class="custom-select disabled" disabled
                    *ngIf="!loadingPricingMatrices && !privateEvent.event_type_id">
              <option>Select an event type first</option>
            </select>
          </div>
        </div>
        <div class="form-text text-danger">
          {{ errors.pricing_matrix_id }}
        </div>
      </div>

      <div class="row" *ngIf="privateEvent.pricing_matrix_id && !loadingPricingMatrices && pricingMatrixList">
        <div class="col-md-10 col-lg-8 col-xl-6">
          <div class="card mb-3">
            <div class="card-body pb-0">
              <app-event-type-pricing-matrix-details [matrix]="getSelectedPricingMatrix()"></app-event-type-pricing-matrix-details>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="row">
          <div class="col-sm-8 col-lg-6">
            <label for="tax_rate_id">Tax Rate</label>
            <div class="float-right">
              <a href="#"
                 (click)="$event.preventDefault();loadTaxRates();">
                Refresh Tax Rates
              </a>
              |
              <a routerLink="/tax-rates-config" target="_blank">
                Configure Tax Rates
              </a>
            </div>
            <select class="custom-select"
                    name="tax_rate_id" id="tax_rate_id"
                    *ngIf="!loadingTaxRates"
                    [(ngModel)]="privateEvent.tax_rate_id"
                    [disabled]="!isNewPrivateEvent"
                    [class.disabled]="!isNewPrivateEvent">
              <option [ngValue]="null">
                Event Type Default
                <ng-container *ngIf="privateEvent.event_type_id">
                  ({{ getSelectedEventTypeTaxRate() }})
                </ng-container>
              </option>
              <option *ngFor="let taxRate of taxRateList"
                      [ngValue]="taxRate.id">
                {{ taxRate.name }} - {{ taxRate.rate_percent }}%
              </option>
            </select>
            <select class="custom-select"
                    *ngIf="loadingTaxRates" disabled>
              <option>Loading...</option>
            </select>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label for="privateNotesInput">Private Notes</label>
        <textarea class="form-control" id="privateNotesInput"
                  rows="3" name="private_notes"
                  [(ngModel)]="privateEvent.private_notes"></textarea>
        <small class="form-text text-muted">
          These notes are visible only to other staff members. They are not shown in the Climber App.
        </small>
        <div class="form-text text-danger">
          {{ errors.private_notes }}
        </div>
      </div>

      <div class="alert alert-danger" role="alert"
           *ngIf="errors.non_field_errors">
        {{ errors.non_field_errors }}
      </div>
      <div class="alert alert-danger" role="alert"
           *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <div class="alert alert-info" role="alert"
           *ngIf="loadingSave">
        Saving...
      </div>

      <!-- Place save button first so that the enter key press activates it -->
      <div class="float-right">
        <!-- Invisible button causes the "enter" keypress to be of submit type continue. -->
        <button type="submit" style="display: none"
                [disabled]="loadingSave"
                (click)="submitType=SUBMIT_TYPE_CONTINUE"></button>
        <button type="submit" class="btn btn-primary mr-2"
                [disabled]="loadingSave" [class.disabled]="loadingSave"
                (click)="submitType=SUBMIT_TYPE_GO_BACK">
          Save and Go Back
        </button>
        <button type="submit" class="btn btn-primary"
                [disabled]="loadingSave" [class.disabled]="loadingSave"
                (click)="submitType=SUBMIT_TYPE_CONTINUE">
          Save and Continue
        </button>
      </div>

      <a class="btn btn-secondary"
         [routerLink]="getBackLink()">
        {{ isNewPrivateEvent ? 'Cancel' : 'Back to Event Details' }}
      </a>

    </form>

  </div>

</div>
